import { AuthState } from '@/contracts/store/AuthContracts'
import { UserStructure } from '@/contracts/UserContracts'

export const Auth =
{
    namespaced: true,
    state: (): AuthState => (
    {
        isAuthenticated: false,
        user: {} as UserStructure,
        paymentId: ''
    }),
    getters:
    {
        isAuthenticated(state: AuthState): boolean
        {
            return state.isAuthenticated
        },
        getUser(state: AuthState): UserStructure
        {
            return state.user
        },
        getPaymentId(state: AuthState): string
        {
            return state.paymentId
        }
    },
    mutations:
    {
        setAuthenticatedUser(state: AuthState, user: UserStructure): void
        {
            state.isAuthenticated = true
            state.user = user
        },
        logout(state: AuthState): void
        {
            state.isAuthenticated = false
            state.user = {} as UserStructure
        },
        setPaymentId(state: AuthState, id: string): void
        {
            state.paymentId = id
        }
    }
}
